import { Typography } from '@mui/material';
import React from 'react';
import './Project.css';
import Slider from './Slider';

const Project = () => {
    return (
        <div>
            <Typography
                variant="h5"
                noWrap
                component="div"
                className='title title-center title-projects'
                sx={{ display: { xs: 'flex', md: 'flex' }, mb: '4' }}>
                Our Projects
            </Typography>
            <Slider />
        </div>
    )
}

export default Project;